import { convertArrayToObject } from 'src/utils'

export async function getAllActiveGiftCards({ commit }) {
  try {
    const { data } = await this.$axiosInstance.get('/GiftCard/MyGiftCard', {
      params: {
        disablePaging: true,
        isActivated: true,
        filters: '(Status)@=1',
        global: true,
      },
    })

    const activeGiftCards = convertArrayToObject(
      data.data.items.filter((item) => item.availableBalance > 0),
      'id'
    )
    commit('SET_FIELD', {
      key: 'myActiveGiftCards',
      value: activeGiftCards,
    })
  } catch (error) {
    // Handle error appropriately
  }
}

export async function findGiftCardByNumber({ commit, getters }, params) {
  try {
    const {
      data: { data },
    } = await this.$axiosInstance.get('/giftCard/getGiftCardDetails', {
      params,
    })

    return data
  } catch (error) {
    throw error
  }
}

export async function getGiftCards({ commit, getters }, params = {}) {
  try {
    const isFirstPage = params.page === 1

    if (isFirstPage) commit('SET_FIELD', { key: 'loading', value: true })

    const {
      data: {
        data: { items = [], hasNext },
      },
    } = await this.$axiosInstance.get('/giftCard', { params })

    commit('SET_FIELD', {
      key: 'giftCards',
      value: isFirstPage ? items : [...(getters.giftCards || []), ...items],
    })

    return hasNext
  } catch {
    return false
  } finally {
    commit('SET_FIELD', { key: 'loading', value: false })
  }
}

export async function getMyGiftCards({ commit }, params) {
  try {
    commit('SET_FIELD', { key: 'loading', value: true })
    let { data } = await this.$axiosInstance.get('/GiftCard/MyGiftCard', {
      params,
    })
    if (data.data) {
      commit('SET_FIELD', { key: 'myGiftCards', value: data.data.items })
    }
    return data.data
  } catch (error) {
  } finally {
    commit('SET_FIELD', { key: 'loading', value: false })
  }
}

// Send GiftCardVia Email
export async function sendGiftCard({}, { params, queryParams }) {
  try {
    const response = await this.$axiosInstance.post(
      '/GiftCard/SendGiftCardViaMail',
      params,
      { params: queryParams }
    )
    return response.data
  } catch (error) {
  } finally {
  }
}

// Active GiftCard
export async function activeGiftCard({}, params) {
  const { myGiftCardId, ActionForStatus, isGuestUser } = params
  const response = await this.$axiosInstance.put(
    `/GiftCard/UpdateGiftCardStatus/${myGiftCardId}`,
    { ActionForStatus, isGuestUser }
  )
  return response.data
}

// Retract GiftCard
export async function retractGiftCard({}, params) {
  const { myGiftCardId, ActionForStatus, isGuestUser } = params
  const response = await this.$axiosInstance.put(
    `/GiftCard/UpdateGiftCardStatus/${myGiftCardId}`,
    { ActionForStatus, isGuestUser }
  )
  return response.data
}

// GiftRevoke GiftCard
export async function revokeGiftCard({}, params) {
  const { myGiftCardId, ActionForStatus, isGuestUser } = params
  const response = await this.$axiosInstance.put(
    `/GiftCard/UpdateGiftCardStatus/${myGiftCardId}`,
    { ActionForStatus, isGuestUser }
  )
  return response.data
}

export async function getGiftCardDetails({ commit, state }, giftCardId) {
  commit('SET_FIELD', { key: 'detailLoading', value: true })

  try {
    const {
      data: { data: giftCardData },
    } = await this.$axiosInstance.get(`/GiftCard/${giftCardId}`)

    commit('SET_FIELD', {
      key: 'giftCardDetails',
      value: {
        ...state.giftCardDetails,
        [giftCardId]: {
          ...giftCardData,
          products: convertArrayToObject(giftCardData.products, 'productType'),
        },
      },
    })

    return giftCardData
  } catch {
    return false
  } finally {
    commit('SET_FIELD', { key: 'detailLoading', value: false })
  }
}

// Claim GiftCard Via Email
export async function claimGiftCard({}, params) {
  const { myGiftCardId, actionForStatus, isGuestUser } = params
  const response = await this.$axiosInstance.put(
    `/GiftCard/UpdateGiftCardStatus/${myGiftCardId}`,
    { actionForStatus, myGiftCardId, isGuestUser }
  )
  return response.data
}

export async function getGiftCardBalance({}, giftCardNumber) {
  try {
    let response = await this.$axiosInstance.get(
      `GiftCard/CheckGiftCardBalance/${giftCardNumber}`
    )
    return response.data
  } catch (error) {
    console.log('error', error)
  }
}

// Find Gift Card
export async function findGiftCard({}, params) {
  try {
    const response = await this.$axiosInstance.post(
      '/GiftCard/FindGiftCard',
      params
    )
    return response.data
  } catch (error) {
    return error
  }
}
